import React, { useState, useEffect } from "react";
import { EaseDrawer } from "../../../../libs/EaseDrawer";
import { Badge, Button, Descriptions, Icon, Popconfirm, Upload, Tooltip, Radio, Dropdown, Menu, Alert, Input, Popover } from "antd";
import { PermissionHoc } from "../../../HOC";
import { alertify, handleApiExceptions, printRupee } from "../../../../app_methods";
import { Text1, Text3, Text4, Text5 } from "../../../../styles";
import { updateCurrentUserAction } from "../../../../redux/actions";
import { connect } from "react-redux";
import { VENDOR_INVOICE_STATUS_TYPES } from "../../../../constants";
import { RecordOfflinePayementModal } from "../../../Common/VendorPayouts/Modals/VendorInvoice/RecordOfflinePayment";
import { PaymentDetailsDrawer } from "./payment_details_drawer";
import { Approvals } from "../../../../models/vendorPayouts";
// import './index.scss';


const VendorInvoiceDetailsDrawer = (props) => {
  const invoice = props.invoice || {};
  const vendor = invoice.vendor || {};
  const invoice_approval = new Approvals(invoice.approval || {});
  const [isPaying, setIsPaying] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [invoiceDoc, setInvoiceDoc] = useState();
  const [forceUpload, setForceUpload] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [paymentMode, setPaymentMode] = useState(false);
  const [showRecordOfflinePaymentModal, setShowRecordOfflinePaymentModal] = useState(false);
  const [showPaymentDetailsDrawer, setShowPaymentDetailsDrawer] = useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [showPopover, setShowPopover] = useState(false);

  const PermissableButton = PermissionHoc(Button, "", { is_component: true, fallbackComponent: null, });
  const PermissableUpload = PermissionHoc(Upload, "", { is_component: true, fallbackComponent: null, });
  const PermissableDropdwonButton = PermissionHoc(Dropdown.Button, "", { is_component: true, fallbackComponent: null, });

  const toggleRecordOfflinePaymentModal = () => {
    setShowRecordOfflinePaymentModal(!showRecordOfflinePaymentModal);
  }

  const togglePaymentDetailsDrawer = () => {
    setShowPaymentDetailsDrawer(!showPaymentDetailsDrawer);
  }

  const processPayment = async () => {
    setIsPaying(true);
    const response = await invoice.initiate_payment({ payment_mode: paymentMode, bank_detail_id: invoice.bank_detail_id });
    if (!response.success) {
      setIsPaying(false);
      setShowPopover(false);
      handleApiExceptions(response);
      return;
    }
    alertify("Success", `Payment initiated successfully.`, "success");
    setIsPaying(false);
    setShowPopover(false);
    props.fetchList();
  };

  const cancelInvoice = async () => {
    setIsCancelling(true);
    const response = await invoice.cancel();
    if (!response.success) {
      setIsCancelling(false);
      handleApiExceptions(response);
      return;
    }
    alertify("Success", `Invoice Cancelled successfully.`, "success");
    setIsCancelling(false);
    props.fetchList();
  };

  const uploadInvoiceDocument = async () => {
    setIsUploading(true);
    const response = await invoice.upload_document({
      file: invoiceDoc,
      key: props.current_user.key,
    });
    if (!response.success) {
      setInvoiceDoc(undefined);
      setIsUploading(false);
      handleApiExceptions(response);
      return;
    }
    alertify("Success", `Document uploaded successfully.`, "success");
    setInvoiceDoc(undefined);
    setForceUpload(false);
    setIsUploading(false);
    props.fetchList();
  };

  const downloadInvoiceDocument = async () => {
    setIsDownloading(true);
    const response = await invoice.download_document();
    if (!response.success) {
      setIsDownloading(false);
      handleApiExceptions(response);
      return;
    }
    setIsDownloading(false);
    props.fetchList();
    window.open(response.data.url, "_blank");
  };

  const approval_action = async (action_type) => {
    if (rejectReason && !/^\s*([0-9a-zA-Z\ \.]*)\s*$/.test(rejectReason)) {
      alertify("Error", "Only alphanumeric values are allowed in reject reason.", "error");
      return;
    }
    setIsApproving(true);
    setIsRejecting(true);
    const response = await invoice_approval.approval_update({ action_type: action_type, reject_reason: rejectReason });
    if (!response.success) {
      setIsApproving(false);
      setIsRejecting(false);
      handleApiExceptions(response);
      setRejectReason("");
      return;
    }
    setRejectReason("");
    setIsApproving(false);
    setIsRejecting(false);
    alertify("Success", response.data.message, "success");
    props.fetchList();
  };

  const renderTitle = () => {
    return (
      <div className="mb-4">
        <Text1 className="d-block" strong>
          Invoice Details
        </Text1>
        <Text5 copyable>{invoice.id}</Text5>
      </div>
    );
  };

  const menu = (
    <Menu onClick={toggleRecordOfflinePaymentModal}>
      <Menu.Item key="1">
        <Icon type="account-book" />
        Record Offline Payment
      </Menu.Item>
    </Menu>
  );

  const paymentOptions1 = [
    {
      label: 'IMPS',
      value: 'IMPS'
    },
    {
      label: 'NEFT',
      value: 'NEFT'
    },
  ]

  const paymentOptions2 = [
    {
      label: 'IMPS',
      value: 'IMPS'
    },
    {
      label: 'NEFT',
      value: 'NEFT'
    },
    {
      label: 'RTGS',
      value: 'RTGS'
    },

  ]

  const paymentOptions3 = [
    {
      label: 'RTGS',
      value: 'RTGS'
    },
    {
      label: 'NEFT',
      value: 'NEFT'
    }

  ]

  const renderPaymentModeOptions = (amount) => {
    return ((amount < 200000) ? paymentOptions1 : (amount >= 200000 && amount <= 500000) ? paymentOptions2 : paymentOptions3)
  }

  const togglePayNowPopover = () => {
    setShowPopover(!showPopover)
  };


  const renderBasicDetails = () => {
    return (
      <div className="mt-4">
        <div className="mt-4 d-flex justify-content-between">
          <Text3 className="d-block" strong>Basic Details</Text3>
          <div>
            <Popover disabled={invoice.status !== 'unpaid'} trigger="click" placement="left" visible={showPopover} onVisibleChange={togglePayNowPopover} content={
              <div className="d-flex flex-column">
                <Text4 strong> Please select payment mode. </Text4>
                <div className="mt-2 mb-3">
                  <Radio.Group options={renderPaymentModeOptions(invoice.total_amount)} onChange={(e) => setPaymentMode(e.target.value)} />
                </div>
                <div className="text-right">
                  <Button className="mr-3" onClick={togglePayNowPopover} size="small">Cancel</Button>
                  <Button type="primary" loading={isPaying} onClick={() => { processPayment();}} size="small" disabled={!paymentMode}>Pay</Button>
                </div>
              </div>
            } >
              {invoice.status == 'unpaid' || 'unapproved' ? (<PermissableDropdwonButton required_permission="VENDOR_INVOICE_WRITE" overlay={menu} disabled={invoice.status !== 'unpaid'} loading={isPaying} size="small" type="primary">
                <span className="mr-2" dangerouslySetInnerHTML={{ __html: `&#8377;` }} />
                <span>Pay Now</span>
              </PermissableDropdwonButton>) : (<PermissableButton required_permission="VENDOR_INVOICE_WRITE" overlay={menu} disabled={invoice.status !== 'unpaid'} loading={isPaying} size="small" type="primary">
                <span className="mr-2" dangerouslySetInnerHTML={{ __html: `&#8377;` }} />
                <span>Pay Now</span>
              </PermissableButton>)}

            </Popover>
            <Popconfirm disabled={invoice.status !== 'unpaid'} onConfirm={cancelInvoice} title="Are you sure you want to cancel this invoice." className="ml-2" >
              <PermissableButton required_permission="VENDOR_INVOICE_WRITE" disabled={invoice.status !== 'unpaid'} loading={isCancelling} size="small" type="danger" icon="stop" ghost> Cancel </PermissableButton>
            </Popconfirm>
          </div>
        </div>
        <Descriptions className="mt-2" title={false} column={1} bordered size="small" >
          <Descriptions.Item label="Vendor Name"> {vendor.name} </Descriptions.Item>
          <Descriptions.Item label="Invoice Number"> {invoice.number} </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Badge
              color={VENDOR_INVOICE_STATUS_TYPES[invoice.status || 'unpaid'].color}
              text={<Text4> {VENDOR_INVOICE_STATUS_TYPES[invoice.status || 'unpaid'].label} </Text4>}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Description"> {invoice.description || '---'} </Descriptions.Item>
          <Descriptions.Item label="Invoice Document">
            {invoice.invoice_document && !forceUpload ? (
              <div className="d-flex justify-content-between">
                <PermissableButton required_permission="VENDOR_INVOICE_WRITE" icon="download" loading={isDownloading} type="link" onClick={() => downloadInvoiceDocument()}> Download </PermissableButton>
                <PermissableButton required_permission="VENDOR_INVOICE_WRITE" icon="edit" onClick={() => setForceUpload(true)} />
              </div>
            ) : (
              <div className="d-flex">
                <PermissableUpload required_permission="VENDOR_INVOICE_WRITE" name="logo" onChange={(e) => { setInvoiceDoc(e.file) }} showUploadList={false} beforeUpload={() => false}>
                  <Button icon="upload">Browse Document</Button>
                </PermissableUpload>
                <Tooltip title={invoiceDoc ? 'Save Document' : 'Select Document'}>
                  <PermissableButton required_permission="VENDOR_INVOICE_WRITE" loading={isUploading} onClick={uploadInvoiceDocument} icon="check" disabled={!invoiceDoc} className="ml-1" />
                </Tooltip>
                {
                  forceUpload ? (
                    <Tooltip title="Cancel Update">
                      <Button onClick={() => setForceUpload(false)} icon="close" type="danger" className="ml-1" ghost />
                    </Tooltip>
                  ) : null
                }
              </div>
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Payment Details">
            <Button className="mr-2 pl-0" onClick={togglePaymentDetailsDrawer} loading={isCancelling} type="link" > View Payment Details </Button>
          </Descriptions.Item>
          {
            invoice.created_by ? (
              <Descriptions.Item label="Created By">{(invoice.created_by || {}).name || '---'}</Descriptions.Item>
            ) : null
          }
        </Descriptions>
      </div>
    );
  };

  const renderTaxDetails = () => {
    return (
      <div className="mt-4">
        <Text3 className="d-block" strong>Amount & Tax Details</Text3>
        <Descriptions className="mt-2" title={false} column={1} bordered size="small" >
          <Descriptions.Item label="Amount"> {printRupee(invoice.amount)} </Descriptions.Item>
          <Descriptions.Item label={`GST (${parseFloat(invoice.gst_percentage || 0).toFixed(2)}%)`}> {printRupee(invoice.gst_amount)}</Descriptions.Item>
          <Descriptions.Item label={`TDS (${parseFloat(invoice.tds_percentage || 0).toFixed(2)}%)`}> {printRupee(invoice.tds_amount)}</Descriptions.Item>
          <Descriptions.Item label="Final Payout Amount"> {printRupee(invoice.total_amount)} </Descriptions.Item>
        </Descriptions>
      </div>
    );
  };

  const alertColor = (invoice_approval) => {
    if (!((invoice_approval.approver || {}).name) && !(invoice_approval.rejecter || {}).name) {
      return "warning";
    }else if (invoice_approval.status === "approved") {
      return "success";
    } else if (invoice_approval.status === "rejected") {
      return "error";
    } else return "info"
  }

  const renderApprovalDetails = () => {
    if (!invoice_approval || !invoice_approval.id) return null;
    return (
      <div className="mt-4">
        <div className="d-flex align-items-center justify-content-between">
          <Text3 className="d-block" strong>Approval</Text3>
          {
            props.current_user.user.role > 1 ? (
              <div>
                <PermissableButton required_permission="VENDOR_INVOICE_WRITE" loading={isApproving} disabled={["approved", "rejected"].includes(invoice_approval.status) || (props.current_user.user.role === 2 && invoice_approval.status === "checked")} type="primary" size="small" className="mr-1" onClick={() => approval_action("APPROVE")} >Approve</PermissableButton>
                <Popconfirm placement="bottom" title={
                  <div>
                    <Text4 strong>Reject Reason:</Text4>
                    <Input value={rejectReason} onChange={(e) => setRejectReason(e.target.value)} />
                  </div>
                } okText="Reject" okType="danger" onConfirm={() => approval_action("REJECT")}>
                  <PermissableButton required_permission="VENDOR_INVOICE_WRITE" loading={isRejecting} disabled={["approved", "rejected"].includes(invoice_approval.status) || (props.current_user.user.role === 2 && invoice_approval.status === "checked")} type="danger" size="small" bordered>Reject</PermissableButton>
                </Popconfirm>
              </div>
            ) : null
          }
        </div>
        <Descriptions className='mt-2' title={false} column={1} bordered size="small">
          <Descriptions.Item label="Maker">{invoice_approval.maker.name || "---"}</Descriptions.Item>
          <Descriptions.Item label="Checker">{invoice_approval.checker.name || "---"}</Descriptions.Item>
          {/* <Descriptions.Item label="Approver">
            {invoice.status === "rejected" ? invoice_approval.rejecter.name : invoice.status === "unpaid" ? invoice_approval.approver.name : "---"}
          </Descriptions.Item> */}
        </Descriptions>
        {
         Object.keys(invoice_approval).length > 1 ? (
            <Alert type={alertColor(invoice_approval)} className="mt-2" message={
              <>
                {!((invoice_approval.approver || {}).name) && !((invoice_approval.rejecter || {}).name) ? <Text4>Waiting for Approval.</Text4> : <Text4>Invoice <strong>{invoice_approval.status}</strong> by {invoice_approval.rejecter.name || invoice_approval.approver.name}.</Text4>}
                {
                  invoice_approval.status === "rejected" && invoice_approval.reject_reason ? <>
                    <br />
                    <Text5>Reason: <i>{invoice_approval.reject_reason}</i></Text5>
                  </> : null
                }
              </>
            } />
          ) : null
        }

      </div>
    )
  }

  return (
    <>
      <EaseDrawer
        className="payout-link-details-drawer"
        visible={props.visible}
        onClose={props.onClose}
        hideHeader
        hideFooter
        width={525}
        destroyOnClose={false}
      >
        <div className="mt-3">
          {renderTitle()}
          {renderBasicDetails()}
          {renderTaxDetails()}
          {renderApprovalDetails()}
        </div>

        <PaymentDetailsDrawer
          togglePaymentDetailsDrawer={togglePaymentDetailsDrawer}
          visible={showPaymentDetailsDrawer}
          onClose={() => togglePaymentDetailsDrawer()}
          vendorInvoice={invoice}
        />



      </EaseDrawer>
      <RecordOfflinePayementModal
        visible={showRecordOfflinePaymentModal}
        onClose={toggleRecordOfflinePaymentModal}
        toggleRecordOfflinePaymentModal={toggleRecordOfflinePaymentModal}
        vendorInvoice={invoice}
        fetchList={props.fetchList}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  current_user: state.userReducer.current_user,
});

const mapDispatchToProps = (dispatch) => ({
  updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorInvoiceDetailsDrawer);
